<section class="cont-delivery-navbar" [ngClass]="{showMenuR: toggleShowR}">
  <div class="cont-title">
    <p class="text-center color-blue">
      <img [ngClass]="{'ico-christmas': christmas}"
      [src]="(!icon) ? '/assets/svg/marker.svg' : icon"
      alt="tipo de envio" />
      {{ nameCity }}
      <app-icons class="icon-component"></app-icons>
    </p>
  </div>

  <div class="tooltip-ftd">
    <div class="triangle d-none d-sm-none d-md-block"></div>
    <div
      id="nav-bar-delivery-type-toggle-responsive"
      class="background d-block d-md-none"
      (click)="toggleDeliveryTimeR()">
    </div>
    <div class="cont-tooltip-ftd">
      <p class="text-title"><strong>Selecciona tu ciudad</strong> {{ deliveryTime.EXPRESS }}</p>
      <hr />
      <ul>
        <li
          [id]="'nav-bar-delivery-type-express-' + city.id"
          *ngFor="let city of arrayCities"
          (click)="changeCity(city)">
          {{ city.name }}
        </li>
      </ul>
      <div
        *ngIf="countryConfig.deliveryTypeComponent.national"
        id="nav-bar-delivery-type-national"
        class="divider"
        (click)="changeCity(deliveryTypes.national)">
        <p class="text-title text-national">
          <strong>Otra ciudad</strong> {{ deliveryTime.NATIONAL }}
        </p>
        <p class="text-center text-description-national">
          <small
            >Llegamos a cualquier parte del país. <br />
            Con Servientrega tus envíos Farmatodo llegarán en {{ deliveryTime.NATIONAL }} al destino
            que elijas</small>
        </p>
      </div>
      <p
        *ngIf="countryConfig.deliveryTypeComponent.envialoYa"
        id="nav-bar-delivery-type-envialo-ya"
        class="text-title text-envialo-ya"
        (click)="changeCity(deliveryTypes.envialoya)">
        <strong>Envio a venezuela</strong> {{ deliveryTime.ENVIALOYA }}
      </p>
      <p
        *ngIf="countryConfig.deliveryTypeComponent.envialoYaText"
        class="text-center text-description-envialo-ya divider"
        routerLink="envialo-ya"
        (click)="toggleDeliveryTimeR()">
        <small>Quiero saber más</small>
      </p>
    </div>
  </div>
</section>
